
import ExternalLink from '@/ui-kit/components/external-link';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ExternalLinks } from '@/utils/external-navigation/constants';
import ListingLicenceDefaultContent from './default';
import ListingLicencePillar9Content from './pillar9';

export default {
  name: 'ListingLicence',
  components: {
    Typography,
    ExternalLink,
    Icon,
  },
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      IconType,
      ExternalLinks,
      TypographyType,
    };
  },
  computed: {
    contentComponent() {
      if (this.listing.isPillar9) {
        return ListingLicencePillar9Content;
      }

      return ListingLicenceDefaultContent;
    },
  },
};
